import {isServer} from 'coreUtils/utils';
import AbstractLogProvider from '../AbstractLogProvider';
import {LogLevel, LogType} from 'sfccAPI/interfaces';
import CommerceAPI from 'commerceAPI';
import {LogSource} from 'commerceAPI/custom-apis/CustomShopperSystem/ICustomShopperSystem';

/**
 * Represents SFCCLogger
 */
class SFCCLogger extends AbstractLogProvider {
	private commerceApi: CommerceAPI;

	/**
	 * @constructor
	 * @param commerceApi - commerce api instance
	 */
	constructor(commerceApi: CommerceAPI) {
		super();

		this.commerceApi = commerceApi;
	}

	/**
	 * Logs error level message
	 * @param {String} title - title
	 * @param {String} source - source
	 * @param {Object} stackTrace - stackTrace
	 * @returns {void}
	 */
	error(title: string, source: LogSource, stackTrace: object): void {
		this.commerceApi.customShopperSystem.log({
			body: {
				level: LogLevel.ERROR,
				type: isServer ? LogType.SERVER : LogType.CLIENT,
				title,
				source,
				stackTrace: typeof stackTrace === 'string' ? {details: stackTrace} : stackTrace,
			}
		});
	}

	/**
	 * Logs error level message
	 * @param {String} title - title
	 * @param {Object} stackTrace - stackTrace
	 * @returns {void}
	 */
	warning(title: string, source: LogSource, stackTrace: object): void {
		this.commerceApi.customShopperSystem.log({
			body: {
				level: LogLevel.WARNING,
				type: isServer ? LogType.SERVER : LogType.CLIENT,
				title,
				source,
				stackTrace: typeof stackTrace === 'string' ? {details: stackTrace} : stackTrace,
			}
		});
	}

	/**
	 * Logs error level message
	 * @param {String} title - title
	 * @param {Object} stackTrace - stackTrace
	 * @returns {void}
	 */
	debug(title: string, source: LogSource, stackTrace: object): void {
		this.commerceApi.customShopperSystem.log({
			body: {
				level: LogLevel.DEBUG,
				type: isServer ? LogType.SERVER : LogType.CLIENT,
				title,
				source,
				stackTrace: typeof stackTrace === 'string' ? {details: stackTrace} : stackTrace,
			}
		});
	}

	/**
	 * Logs error level message
	 * @param {String} title - title
	 * @param {Object} stackTrace - stackTrace
	 * @returns {void}
	 */
	info(title: string, source: LogSource, stackTrace: object): void {
		this.commerceApi.customShopperSystem.log({
			body: {
				level: LogLevel.INFO,
				type: isServer ? LogType.SERVER : LogType.CLIENT,
				title,
				source,
				stackTrace: typeof stackTrace === 'string' ? {details: stackTrace} : stackTrace,
			}
		});
	}
}

export default SFCCLogger;
